var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loginType === "scan"
      ? _c("div", { staticClass: "title" }, [_vm._v("扫码登录")])
      : _vm._e(),
    _vm.loginType === "wx"
      ? _c("div", { staticClass: "title" }, [_vm._v("云滴管家微信授权登录")])
      : _vm._e(),
    _c("div", { staticClass: "code-area" }, [
      _c(
        "div",
        { staticClass: "code-content" },
        [
          _vm.qrCodeUrl
            ? _c("vue-qr", {
                ref: "qrCode",
                attrs: { text: _vm.qrCodeUrl, size: 228, margin: 0 },
              })
            : _vm._e(),
          _vm.showMask
            ? _c(
                "div",
                { staticClass: "code-mask" },
                [
                  _c("div", { staticClass: "code-mask-tip" }, [
                    _vm._v(_vm._s(_vm.maskTip)),
                  ]),
                  _vm.qrCodeTime === 0 ||
                  _vm.qrCodeTime < 0 ||
                  _vm.qrCodeStatus === 4
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "success",
                            size: "mini",
                            loading: _vm.refreshLoading,
                          },
                          on: { click: _vm.getQrCode },
                        },
                        [_vm._v("\n          请点击刷新\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "tip" },
      [
        _c("div", [_vm._v("请使用")]),
        _c(
          "el-button",
          { attrs: { type: "text" }, on: { click: _vm.goPage } },
          [_vm._v("云滴管家")]
        ),
        _c("div", [_vm._v("扫码登录")]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }